export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  // {
  //   field: 'col-opt',
  //   title: that.$l('INDEX.table_label_operation') || '操作',
  //   headerAlign: 'center',
  //   align: 'center',
  //   fixed: 'left',
  //   width: 80,
  //   slots: { default: 'opt', },
  //   visible: !that.disabled
  // },
  {
    title: that.$l('tc_fabric_sales_detail_fabricNo') || 'TC面料编号',
    field: 'fabricNo',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('tc_fabric_sales_detail_fabricName') || 'TC面料名称',
    field: 'fabricName',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('tc_fabric_sales_detail_fabricWeight') || 'TC面料克重',
    field: 'fabricWeight',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('tc_fabric_sales_detail_fabricColor') || 'TC面料颜色',
    field: 'fabricColor',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_goods_label_qty') || '数量',
    field: 'qty',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('tc_fabric_sales_detail_fabricUnit') || 'TC面料单位',
    field: 'fabricUnitText',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_price') || '单价',
    field: 'unitPrice',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        placeholder: '请输入',
        controlsPosition: 'right',
        style: 'width:100%',
        min: 0,
        step: 0.01,
        precision: 4,
      },
    },
  },
  {
    title: that.$l('INDEX.order_goods_label_subAmount') || '小计金额',
    field: 'v_subAmount',
    width: 120,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  // {
  //   title: that.$l('tc_fabric_sales_detail_fabricWidth') || 'TC面料门幅',
  //   field: 'fabricWidth',
  //   width: 150,
  //   headerAlign: 'center',
  //   align: 'left',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  //   editRender: {
  //     name: 'ElInputNumber',
  //     props: {
  //       placeholder: '请输入',
  //       controlsPosition: 'right',
  //       style: 'width:100%',
  //       min: 0,
  //       step: 0.01,
  //       precision: 4,
  //     },
  //   },
  // },
  // {
  //   title: that.$l('tc_fabric_sales_detail_fabricWidthUnit') || 'TC门幅单位',
  //   field: 'fabricWidthUnit',
  //   width: 150,
  //   headerAlign: 'center',
  //   align: 'left',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  //   editRender: {
  //     name: 'dict-select',
  //     props: {
  //       placeholder: '请选择',
  //       body: { dictType: 'widUnit' },
  //       url: '/master/common/dict/biz',
  //       filterable: true,
  //       clearable: true,
  //     },
  //   },
  // },
  // {
  //   title:
  //     that.$l('tc_fabric_sales_detail_factoryNumber') || '工厂TC面料编号',
  //   field: 'factoryNumber',
  //   width: 150,
  //   headerAlign: 'center',
  //   align: 'left',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  //   editRender: {
  //     name: 'ElInput',
  //     props: {
  //       placeholder: '请输入',
  //       style: 'width:100%',
  //     },
  //   },
  // },
]
